module.exports = __webpack_public_path__ + "media/components/assets/images/makeyourdream/image7_dochimom-4f0451fd7d3d57388bcfe11aa0aa3368.png";